import Checkbox from '@cobliteam/ui/form/Checkbox';
import Label from '@cobliteam/ui/form/Label';

import { getDeviceStatusLabel } from '@cobliteam/common-types';

import type { DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';

interface DeviceStatusItemProps {
  checked: boolean;
  status: DeviceGeneralStatus;
  count: number | null;
  onChange: () => void;
}

const DeviceStatusItem = ({ checked, count, status, onChange }: DeviceStatusItemProps) => {
  const statusLabel = getDeviceStatusLabel(status);
  const label = `${statusLabel} (${count})`;
  return (
    <div className='flex items-center gap-2'>
      <Checkbox key={`device-${status}`} id={`device-${status}`} checked={checked} onCheckedChange={onChange} />
      <Label htmlFor={`device-${status}`}>{label}</Label>
    </div>
  );
};
export default DeviceStatusItem;
